import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { monthClosingFilterStatusSelector, monthClosingChangeFilterStatus } from '../../../state';
import { MonthClosingStatus } from '../../../types';
import { SelectFlexSales, SimpleSelectProps } from '../../selects';

type StatusFilterProps = Pick<SimpleSelectProps, 'fullWidth'>;

const statuses = [MonthClosingStatus.active, MonthClosingStatus.annuled];

const StatusFilter = (props: StatusFilterProps) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const value = useSelector(monthClosingFilterStatusSelector);

  const handleChange = useCallback(
    (newValue: MonthClosingStatus | null) => dispatch(monthClosingChangeFilterStatus(newValue)),
    [dispatch]
  );

  return (
    <SelectFlexSales
      {...props}
      label={t('monthClosing.columns.status')}
      onChange={handleChange}
      value={value}
      options={statuses}
    />
  );
};

export default StatusFilter;
